import { render, staticRenderFns } from "./InsectPests.vue?vue&type=template&id=c4f7ed14&scoped=true"
import script from "./InsectPests.vue?vue&type=script&lang=ts"
export * from "./InsectPests.vue?vue&type=script&lang=ts"
import style0 from "./InsectPests.vue?vue&type=style&index=0&id=c4f7ed14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f7ed14",
  null
  
)

export default component.exports